function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Object, inputValue, recipientInputEl, textInputIdx) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['text-input'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'text-input-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-autoresizing-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              elref: `emailRecipientsInput`,
              focus: true,
              'initial-width': `200px`,
              'input-style-overrides': JSON.stringify({
                'font-size': `16px`,
                'max-width': `440px`,
              }),
              'style-override': `input {background: none;}`,
            }),
            "hook": {
              insert: $helpers.handleRecipientInputInsert,
            },
            "on": {
              click: ev => ev.stopPropagation(),
              /* prevent text input caret clicks from trigger container clicks which could destroy current the text input element */
              input: ({
                target
              }) => $component.update({
                inputValue: target.value
              }),
              focusout: $helpers.handleRecipientInputFocusOut,
              keydown: $helpers.handleRecipientInputKeydown,
            },
            "props": {
              value: inputValue,
            },
            "class": {
              'text-input': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
            "attrs": __vjadeStringifyAttrsIfObj({
              open: Boolean(inputValue)
            }),
            "class": {
              'members-dropdown': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                elref: `emailRecipientsInputSearchList`,
                'search-filter': inputValue,
              }),
              "props": {
                keydownProxyEl: Boolean(inputValue) ? recipientInputEl : null,
                /* stop <mp-items-menu> from stealing keystrokes while closed */
                sections: [$helpers.getProjectMembersMenuSection()],
                sectionsFromInputFn: $helpers.recipientFromInput,
              },
              "on": {
                click: ev => ev.stopPropagation(),
                mousedown: ev => ev.preventDefault(),
                /* prevent <mp-items-menu> clicks from losing focus from the recipient input */
                clickItem: $helpers.clickedProjectMember,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "attrs": __vjadeStringifyAttrsIfObj({
          elref: `emailRecipientsEmailContainer`,
        }),
        "on": {
          click: $attr(`disabled`) ? null : $helpers.handleContainerClick
        },
        "class": Object.assign({}, {
          'disabled': $attr(`disabled`),
          'borderless': $attr(`borderless`),
        }, {
          'container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((($attr(`recipients`).length === 0) && !inputValue) ? ((function() {
          var __jade_nodes = []; /*  use snabbdom key to prevent .empty-state DOM removal from affecting other elements */
          __jade_nodes = __jade_nodes.concat(h("div", {
            "key": `empty`,
            "class": {
              'empty-state': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("No recipients");;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = ($attr(`recipients`));
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, recipient, idx) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((textInputIdx === idx) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(jade_mixins['text-input'].call(this));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  const isDuplicate = $helpers.checkRecipientIfSubsequentDuplicate(recipient, idx);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'recipient': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        clickable: !$attr(`disabled`),
                        icon: recipient.id ? `profile` : ``,
                        removable: !$attr(`disabled`),
                        size: `small`,
                        'tag-name': recipient.id ? recipient.name : recipient.email,
                        theme: (recipient.invalidAddress || isDuplicate) ? `invalid` : `light`,
                      }),
                      "on": {
                        click: ev => ev.stopPropagation(),
                        /* prevent tag clicks from triggering .container element's click handler */
                        select: $attr(`disabled`) ? null : () => $helpers.selectRecipientAt(idx),
                        remove: $attr(`disabled`) ? null : () => $helpers.removeRecipientAt(idx),
                      },
                      "props": {
                        value: recipient
                      },
                    }));
                    __jade_nodes = __jade_nodes.concat((recipient.invalidAddress) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placement: `bottom`
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Invalid email address");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : (isDuplicate) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placement: `bottom`
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Duplicate " + (recipient.id ? `user` : `email address`) + "");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var idx = $$objKey;
                if ($$obj.hasOwnProperty(idx)) {
                  $$iterated = true;
                  var recipient = $$obj[idx];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((textInputIdx === idx) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(jade_mixins['text-input'].call(this));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      const isDuplicate = $helpers.checkRecipientIfSubsequentDuplicate(recipient, idx);
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'recipient': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            clickable: !$attr(`disabled`),
                            icon: recipient.id ? `profile` : ``,
                            removable: !$attr(`disabled`),
                            size: `small`,
                            'tag-name': recipient.id ? recipient.name : recipient.email,
                            theme: (recipient.invalidAddress || isDuplicate) ? `invalid` : `light`,
                          }),
                          "on": {
                            click: ev => ev.stopPropagation(),
                            /* prevent tag clicks from triggering .container element's click handler */
                            select: $attr(`disabled`) ? null : () => $helpers.selectRecipientAt(idx),
                            remove: $attr(`disabled`) ? null : () => $helpers.removeRecipientAt(idx),
                          },
                          "props": {
                            value: recipient
                          },
                        }));
                        __jade_nodes = __jade_nodes.concat((recipient.invalidAddress) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              placement: `bottom`
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Invalid email address");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : (isDuplicate) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              placement: `bottom`
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("Duplicate " + (recipient.id ? `user` : `email address`) + "");;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());
        __jade_nodes = __jade_nodes.concat((textInputIdx === $attr(`recipients`).length) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['text-input'].call({
            block: function() {
              return (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("// input for new recipient");;
                return __jade_nodes
              }).call(this);
            }
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "inputValue" in locals ? locals.inputValue : typeof inputValue !== "undefined" ? inputValue : undefined, "recipientInputEl" in locals ? locals.recipientInputEl : typeof recipientInputEl !== "undefined" ? recipientInputEl : undefined, "textInputIdx" in locals ? locals.textInputIdx : typeof textInputIdx !== "undefined" ? textInputIdx : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;